<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card class="pa-1 mb-1">
        <v-list-item class="px-1">
            <v-list-item-content class="pa-1 ma-0 body-2">
                <v-list-item-title class="title body-2">
                    {{post.title}}
                </v-list-item-title>
                <v-list-item-subtitle class="title body-2">
                    {{post.text}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions class="py-0">
            <v-container fluid class="py-0">
                <v-row>
                    <v-col cols="9" md="9" class="pa-0 pa-0 d-flex">
                        <v-tooltip right>
                            <template v-slot:activator="{ on }">
                                <span v-on="on" class="text-center align-self-center"
                                >
                                    {{formattedDate}} {{formattedTime}}
                                </span>
                            </template>
                            <span class="caption">Дата опубликования поста</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="3" class="pa-0 pa-0">
                        <v-btn
                               x-small
                               icon
                               color="blue lighten-3"
                               @click="$emit('editMailing', index)"
                            v-if="status !== 2"
                        >
                            <v-icon small>edit</v-icon>
                        </v-btn>
                        <v-btn x-small icon @click="$emit('viewMailing', index)"
                               v-if="status === 2"
                        >
                            <v-icon small>remove_red_eye</v-icon>
                        </v-btn>
                        <v-btn
                               x-small
                               icon
                               color="red lighten-3"
                               @click="removeMailing">
                            <v-icon small>delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row justify="start" v-if="post.status !== 'primary'">
                    <!--<v-col class="pa-0 px-1">
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-card
                                        v-on="on"
                                        class="text-center body-2"
                                        outlined
                                >
                                    <v-icon small>send</v-icon>
                                    {{delivered}}/{{allUsers}}
                                </v-card>
                            </template>
                            <span class="body-2">Доставлено {{delivered}} из {{allUsers}}</span>
                        </v-tooltip>
                    </v-col>
                    <v-col class="pa-0 px-1">
                        <v-tooltip left>
                            <template v-slot:activator="{ on }">
                                <v-card
                                        v-on="on"
                                        class="text-center body-2"
                                        outlined
                                >
                                    <v-icon small>drafts</v-icon>
                                    {{readed}}/{{delivered}}
                                </v-card>
                            </template>
                            <span class="body-2">Прочитали {{readed}} из {{delivered}}</span>
                        </v-tooltip>
                    </v-col>-->
                </v-row>
            </v-container>
        </v-card-actions>
        <dialog-confirmation ref="confirm" :dialogParams="dialogParams"></dialog-confirmation>
    </v-card>
</template>

<script>
import DialogConfirmation from '../../../dialogs/DialogConfirmation'

export default {
    name: 'MailingCard',
    props: ['post', 'index', 'status'],
    components: {
        DialogConfirmation
    },
    data() {
        return {
            dialogParams: {}
        }
    },
    methods: {
        editMailing() {
            this.$emit('editMailing', this.index)
        },
        async removeMailing() {
            this.$refs.confirm.open('Удаление рассылки', 'Вы действительно хотите удалить?',
                { color: 'red', cancel: 'Отмена', agree: 'Подтверждаю' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('posts/deleteMailing', this.index)
                    }
                })
        },
        zero(number) {
            if (number < 10) {
                number = '0' + number
            }
            return number
        }
    },
    computed: {
        formattedDate() {
            let theDate = new Date(this.post.post_time * 1000)
            return this.zero(theDate.getDate()) + '.' + this.zero((theDate.getMonth() + 1)) + '.' + theDate.getFullYear()
        },
        formattedTime() {
            let theDate = new Date(this.post.post_time * 1000)
            return this.zero(theDate.getHours()) + ':' + this.zero((theDate.getMinutes()))
        },
        delivered() {
            return this.post.status === 'primary' ? 0 : this.post.delivered
        },
        allUsers() {
            return this.post.status === 'primary' ? 0 : this.post.all_users
        },
        readed() {
            return this.post.status === 'primary' ? 0 : this.post.readed
        }
    }
}
</script>

<style scoped>

</style>
